import { takeLatest, put, all, call } from 'redux-saga/effects';
import {
    startAllPricingList,
    setPricingListData,
    startFetchFilterDropdown,
    setFilterDropdownData,
    completedFetch
} from './pricingList.slice';
import { filtersDropdownApi, pricingListApi } from 'utils/apis/pricingListApi';
import { openSnackbar } from '../snackbar';

function* pricingListFn(payload) {
    try {
        const data = yield call(pricingListApi, payload);
        yield put(setPricingListData(data));
        yield put(completedFetch());
    } catch (err) {
        yield put(
            openSnackbar({
                open: true,
                message: err.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedFetch());
    }
}

function* pricingListWatcher() {
    yield takeLatest(startAllPricingList.type, pricingListFn);
}

// 2nd watcher
function* filterDropdownFn() {
    try {
        const data = yield call(filtersDropdownApi);
        yield put(setFilterDropdownData(data));
        yield put(completedFetch());
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(completedFetch());
    }
}

function* pricingFilterWatcher() {
    yield takeLatest(startFetchFilterDropdown.type, filterDropdownFn);
}

export default function* pricingListSaga() {
    yield all([call(pricingListWatcher), call(pricingFilterWatcher)]);
}
